<script setup>
import { computed, defineProps, ref } from 'vue'
import { t, fm } from '@/i18n'
import { mediaTypeRef } from '@/model/media'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

const props = defineProps({
    list: [Array],
    currentLevel: [Object]
})

const earnHotelItemsToShow = computed(()=> {
  let _val = mediaTypeRef.value
  let _res = 1
  if(_val == '2xl') {
    _res = 4.2
  }else if(_val == 'xl') {
    _res = 3.2
  }else if(_val == 'lg') {
    _res = 2.5
  }else if(_val == 'md') {
    _res = 2.2
  }else if(_val == 'sm') {
    _res = 1.5
  }else {
    _res = 1
  }
  return _res
})
</script>

<template>
    <section class="px-4 py-20 text-default text-sm bg-body">
      <div class="w-full px-8 mb-12 text-center relative">
        <div class="flex items-end justify-center">
          <IconStar class="w-4 h-4 text-gray-light" />
          <IconStar class="w-5 h-5 text-third" />
          <IconStar class="w-4 h-4 text-gray-light" />
        </div>
        <h3 class="mt-3 text-2xl text-theme font-bold font-mont">{{t('收入最高的酒店')}}</h3>
        <em class="w-12 h-1 mt-3 mx-auto bg-minor rounded-full block"></em>
        <p class="mt-3 text-xs text-gray-default"><b>{{t('我们的合作酒店收入最高。')}}</b></p>
      </div>
      <Carousel id="hot-hotel" :items-to-show="earnHotelItemsToShow" :wrap-around="true">
        <Slide v-for="(item,index) in list" :key="index">
          <div class="w-full px-3">
            <div class="w-full bg-default text-default rounded-md overflow-hidden">
              <div class="w-full h-[250px] relative">
                <WiImage :src="item.img" autoH fit="top" class="h-full" />
                <!-- <div class="px-4 py-2 bg-teal-400 text-white text-xs rounded-r absolute right-4 top-4">
                  <em class="w-0 h-0 block border-t-teal-400 border-l-transparent border-t-[14px] border-l-[16px] absolute -left-[15px] top-0"></em>
                  <em class="w-0 h-0 block border-b-teal-400 border-l-transparent border-b-[14px] border-l-[16px] absolute -left-[15px] top-4"></em>
                  <span>{{t('回报')}} {{currentLevel.pre_order}}%</span>
                </div> -->
                <dl class="w-full px-4 py-3 text-white bg-gradient-to-b from-transparent to-theme absolute left-0 bottom-0 flex items-center">
                  <dd class="w-1/2 flex items-center flex-wrap">
                    <IconStar class="w-4 h-4 mx-0.5 text-third" />
                    <IconStar class="w-4 h-4 mx-0.5 text-third" />
                    <IconStar class="w-4 h-4 mx-0.5 text-third" />
                    <IconStar class="w-4 h-4 mx-0.5 text-third" />
                  </dd>
                  <dd class="w-1/2 flex justify-end">
                    <div class="text-xs text-right">
                      <p>{{t('好评')}}</p>
                      <p>{{item.reviews||100}} {{t('条评论')}}</p>
                    </div>
                    <div class="px-2 ml-2 ctx-theme rounded flex items-center" style="box-shadow: 0px 0px 0px 3px rgba(255,255,255,0.2)">
                      <span>{{item.good||3}}</span>
                    </div>
                  </dd>
                </dl>
              </div>
              <div class="p-4 text-left">
                <h5 class="mb-3 text-base text-minor font-bold">{{item.hotel_name}}</h5>
                <p>
                  <IconMapPin class="w-3 h-3 text-third inline-block align-middle" />
                  <b class="ml-1 text-xs text-gray-default inline-block align-middle">{{item.area_name}}</b>
                </p>
                <!-- <i class="w-full mt-4 mb-3 border-t border-default block"></i>
                <button class="px-3 py-2 text-xs bg-gray-100 rounded border border-default">
                  <span>{{t('平均每晚')}} </span>
                  <span class="text-minor">{{fm(item.price||0)}}</span>
                </button> -->
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>
    </section>
</template>